import Form, {
  formCreate,
} from '../../../../../../components/form';
import request from '../../../../../../utils/request';
import ChangeForm from './form-change';
import AdjustmentForm from './form-edit-adjust';

formCreate.component('ChangeForm', ChangeForm);
formCreate.component('AdjustmentForm', AdjustmentForm);

export default {
  extends: Form,
  components: {
    formCreate: formCreate.$form(),
  },
  data() {
    return {
      formFunctionCode: 'main-form',
      formParentCode: 'CRM20260203000000002',
      buttons: {
        submit: true,
        close: true,
        submitAudit: true,
      },
      buttonText: {
        submit: '暂存',
        submitAudit: '保存并提交',
        close: '关闭',
      },
      fChange: null, // ChangeForm this实例
      fAdjust: null, // AdjustmentForm this实例
    };
  },
  methods: {
    // 设置rule
    setRule(item) {
      const v = item;
      v.props = {
        ...v.props,
        formConfig: this.formConfig,
      };
      if (v.field === 'oprType') {
        v.on = {
          ...v.on,
          change: (e) => {
            if (e === '变更') {
              this.hiddenFields(true, ['AdjustmentForm']);
              this.hiddenFields(false, ['ChangeForm']);
            } else if (e === '调整') {
              this.hiddenFields(true, ['ChangeForm']);
              this.hiddenFields(false, ['AdjustmentForm']);
            }
          },
        };
      } else if (v.field === 'ChangeForm') {
        v.on = {
          ...v.on,
          setChangeData: (e) => {
            this.fChange = e; // 获取ChangeForm示例this
          },
        };
      } else if (v.field === 'AdjustmentForm') {
        v.on = {
          ...v.on,
          setChangeData: (e) => {
            this.fAdjust = e; // 获取AdjustmentForm示例this
          },
        };
      }
      return v;
    },
    // 表单渲染完成后回调
    formComplete() {
      this.hiddenFields(true, ['ChangeForm', 'AdjustmentForm']);
      if (this.formConfig.code === 'edit' || this.formConfig.code === 'view') {
        request
          .get('/tpm/tpmFeeBudgetAuditController/queryDetailById', {
            id: this.formConfig.row.id,
          })
          .then((res) => {
            if (res.success) {
              if (res.result.oprType === 'change') {
                this.hiddenFields(false, ['ChangeForm']);
                this.setValue({
                  oprType: res.result.oprType,
                  ChangeForm: {
                    srcFeeBudgetCode: res.result.srcFeeBudgetCode,
                    feeBudgetType: res.result.srcFeeBudgetType,
                    ext1: res.result.srcBudgetYear,
                    orgName: res.result.srcOrgName,
                    budgetSubjectsName: res.result.srcBudgetSubjectsName,
                    ext8: res.result.srcExt8,
                    productLevelName: res.result.srcProductLevelName,
                    canUseAmount: res.result.srcCanUseAmount,
                    remarks: res.result.remarks,
                    changeType: res.result.changeType,
                    changeAmount: res.result.changeAmount,
                    afterAdjustAmount: res.result.srcAfterAdjustAmount,
                    businessRemarks: res.result.businessRemarks || '',
                    attachmentList: res.result.attachmentList || [],
                  },
                });
              } else if (res.result.oprType === 'adjust') {
                this.hiddenFields(false, ['AdjustmentForm']);
                this.setValue({
                  oprType: res.result.oprType,
                  AdjustmentForm: { ...res.result },
                });
              }
            }
          });
      }
    },
    // 提交
    submit(type) {
      const formData = this.getFormData(); // 获取表单的值
      if (formData.oprType) {
        const url = '/tpm/tpmFeeBudgetAuditController/addOrUpdate';
        let params = {
          oprType: formData.oprType,
          submitType: type,
        };
        if (formData.oprType === 'change') {
          const fFormData = this.fChange.getFormData();
          params = {
            ...params,
            changeType: fFormData.changeType,
            changeAmount: fFormData.changeAmount,
            srcFeeBudgetCode: fFormData.srcFeeBudgetCode,
            businessRemarks: fFormData.businessRemarks || '',
            attachmentList: fFormData.attachmentList || [],
          };
        } else if (formData.oprType === 'adjust') {
          params = {
            ...params,
            srcFeeBudgetCode: this.fAdjust.$refs.leftForm.getFieldValue('feeBudgetCode'),
            targetFeeBudgetCode: this.fAdjust.$refs.rightForm.getFieldValue('feeBudgetCode'),
            changeAmount: this.fAdjust.$refs.leftForm.getFieldValue('changeAmount'),
            businessRemarks: this.fAdjust.$refs.leftForm.getFieldValue('businessRemarks') || '',
            attachmentList: this.fAdjust.$refs.leftForm.getFieldValue('attachmentList') || [],
          };
        }
        if (this.formConfig.code === 'edit') {
          params.id = this.formConfig.row.id;
        }
        if (type === 2) {
          this.$emit('submit', {
            row: {
              ...params,
            },
            submitUrl: url,
          });
        } else {
          request.post(url, params).then((res) => {
            if (res.success) {
              this.$message({
                type: 'success',
                message: '操作成功',
              });
              this.$emit('onClose');
              this.$emit('onGetList');
            }
          });
        }
      }
    },
  },
};
